// Constants
import constants from '@/i18n/en/constants';

/* --- GETTERS --- */

/**
 * Getters receive state as input. They do not get access to commit or dispatch
 * @param {*} state - current state of the store created through VueX
 */

/**
 * Returns a boolean representing if the insurance type is sfm (default).
 */
const GET_IS_INSURANCE_SFM = state => {
  return state.insuranceType && state.insuranceType.key === constants.sfmInsuranceTypeKeyDefault;
};

/**
 * Returns a boolean representing if the insurance type is sfi.
 */
const GET_IS_INSURANCE_SFI = state => {
  return state.insuranceType && state.insuranceType.key === constants.sfiInsuranceTypeKey;
};

export default {
  GET_IS_INSURANCE_SFM,
  GET_IS_INSURANCE_SFI
}



// WEBPACK FOOTER //
// ./src/store/getters.js